import { render, staticRenderFns } from "./EditPriceByCategory.vue?vue&type=template&id=23187ce7"
import script from "./EditPriceByCategory.vue?vue&type=script&lang=js"
export * from "./EditPriceByCategory.vue?vue&type=script&lang=js"
import style0 from "./EditPriceByCategory.vue?vue&type=style&index=0&id=23187ce7&prod&lang=css"
import style1 from "../../assets/styles/multiselect.css?vue&type=style&index=1&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports